import { useMemo, useState } from 'react';

import { TopologySubscription } from '../../../../../services/eventingApi';

export const useConsumerSearch = (subscriptions: TopologySubscription[]) => {
  const [search, setSearch] = useState('');
  const visible = useMemo(() => {
    const term = search.trim().toLowerCase();
    return term ? subscriptions.filter((row) => row.consumer.toLowerCase().includes(term)) : subscriptions;
  }, [search, subscriptions]);

  return { search, setSearch, visible };
};
